import styled, { css } from 'styled-components';
import { Modal } from 'react-bootstrap';
import OutlinedButton from 'components/layout/form/outlinedButton';
import ContainedButton from 'components/layout/form/containedButton';
import TextField from 'components/layout/form/textField';

type SeparatorProps = {
  marginTop?: number;
  marginBottom?: number;
};

type LabelProps = {
  forHtml?: string;
};

export const ModalHeader = styled(Modal.Header)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: unset;

  .btn-close,
  .close {
    color: #11117f;
    font-size: 2.4rem;
    font-weight: 500;
    font-family: 'Mangueira', sans-serif;
    align-self: baseline;
  }
`;

export const ButtonConfirm = styled(ContainedButton)`
  width: 270px;
  height: 55px;
  background: #000fff;
  border: 1px solid #000fff;
  box-sizing: border-box;
  border-radius: 6px;

  @media (max-width: 632px) {
    margin-top: 8px;
    width: 100%;
  }
`;

export const ButtonCancel = styled(OutlinedButton)`
  width: 270px;
  height: 55px;
  border: 1px solid #000fff;
  box-sizing: border-box;
  border-radius: 6px;

  @media (max-width: 632px) {
    width: 100%;
  }
`;

export const ModalTitleWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-content: center;

  @media (max-width: 632px) {
    margin-top: 8px;
    flex-direction: column;
  }
`;

export const ModalTitle = styled(Modal.Title)`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #8a8e9d;

  @media (max-width: 632px) {
    font-size: 14px;
  }
`;

export const ModallTitleText = styled.span`
  font-size: 12px;
  line-height: 14px;
  color: #8a8e9d;
  width: 399px;
  margin-left: 19px;

  @media (max-width: 632px) {
    margin-top: 8px;
    margin-left: 0;
    width: 328px;
  }

  @media (max-width: 412px) {
    width: 236px;
  }
`;

export const ModalBody = styled(Modal.Body)``;

export const ModalContent = styled.div``;

export const FormComponent = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: -12px;
  margin-bottom: 20px;
`;

export const ButtonsWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  margin-top: 16px;

  @media (max-width: 632px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
`;

export const Label = styled.label<LabelProps>`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #074f8c;

  display: flex;
  flex-direction: column;

  + Label {
    margin-top: 47px;
  }
`;

export const ErrorMessage = styled.span`
  margin-top: 4px;
  color: #cd0000;
  font-size: 12px;
  line-height: 14px;
`;

export const Input = styled(TextField)`
  width: 315px;
  height: 40px;
  border: 1px solid #c1c1c1;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 14px;
  outline: unset !important;
  padding: 14px 8px 12px;

  @media (max-width: 412px) {
    width: 262px;
  }
`;

export const Separator = styled.div<SeparatorProps>`
  width: 567px;
  height: 0px;
  border-bottom: 1px dashed #c1c1c1;

  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: ${marginTop}px;
    `}

  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: ${marginBottom}px;
    `}

  @media (max-width: 632px) {
    width: 439px;
  }

  @media (max-width: 480px) {
    width: 382px;
  }

  @media (max-width: 440px) {
    width: 352px;
  }

  @media (max-width: 412px) {
    width: 252px;
  }
`;

export const WrapAlterSuccess = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;

  button {
    width: 270px;
    height: 55px;
    background: #000fff;
    border: 1px solid #000fff;
    box-sizing: border-box;
    border-radius: 6px;
    margin-top: 72px;
  }
`;

export const TextAlterSuccess = styled.span`
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #8a8e9d;
`;
